import React from 'react';

import ShiftActions from '../actions/ShiftActions';

import withRouter from '../utils/with-router';

@withRouter
class DashboardHeader extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            draftCreated: false
        };
    }

    componentWillReceiveProps() {
        if (this.props.query && this.props.query.draft_saved) {
            this.setState({draftCreated: true});
            setTimeout(() => {this.setState({draftCreated: false})}, 5000);
        }
    }

    createShift() {
        ShiftActions.setCreateShiftDate('');
        this.context.router.transitionTo('createshift');
    }

    getNavItems() {
        const tab = this.props.selectedTab;
        const rightButtons = (
            <div className="right">
                <div className={"data-info " + (this.state.draftCreated ? "saved" : "")}>Draft saved</div>
                <a href="#" onClick={this.createShift.bind(this)} className="btn btn-green btn-new-shift">New shift</a>
            </div>
        );

        if (this.props.isPro) {
            return (
                <div className="maxwidth-wrapper">
                    <div className="left">
                        <h1 className="page-title">My shifts</h1>
                            <ul className="navi">
                                <li onClick={this.props.changeTab.bind(this, 'agenda')} className={tab === 'agenda' ? "active" : ""}><button>Agenda</button></li>
                            </ul>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="maxwidth-wrapper">
                    <div className="left">
                        <h1 className="page-title">Dashboard</h1>
                            <ul className="navi">
                                <li onClick={this.props.changeTab.bind(this, 'agenda')} className={tab === 'agenda' ? "active" : ""}><button>Agenda</button></li>
                                <li onClick={this.props.changeTab.bind(this, 'week')} className={tab === 'week' ? "active" : ""}><button>Week</button></li>
                                <li onClick={this.props.changeTab.bind(this, 'report')} className={tab === 'report' ? "active" : ""}><button>Monthly report</button></li>
                            </ul>
                    </div>
                    {tab === 'report' ? null : rightButtons}
                </div>
            );
        }
    }

    render () {
        return (
            <header className="dashboard-header">
                {this.getNavItems()}
            </header>
        );
    }
}

export default DashboardHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/DashboardHeader.js
 **/